<template>
  <div class="main-wrap">
    <div id="main-content">
      <div class="wrapper">
        <div class="table-agile-info">
          <jm-crumbs/>
          <el-form>
            <div class="basic-title"><em>报账业绩目标</em></div>
            <div>
              <el-button
                type="primary"
                class="add_button"
                @click="handleAdd">设定目标业绩</el-button>
            </div>
            <div>
              部门：
              <el-select
                v-model="searchData.departmentId"
                filterable
                clearable
                placeholder="请选择">
                <el-option
                  v-for="item in department"
                  :key="item.id"
                  :label="item.department"
                  :value="item.id"/>
              </el-select>
              月份：
              <el-date-picker
                v-model="searchData.time"
                type="month"
                value-format="yyyy-MM"
                placeholder="请选择月份"/>
            </div>
            <div class="button">
              <el-button
                type="primary"
                @click="sendForm">查询</el-button>
              <el-button
                type="primary"
                @click="resetForm">重置</el-button>
            </div>
          </el-form>
          <jm-tableList
            url="/index/B_I_Department/departmentMoney"
            :refresh.sync="refresh"
            :search-data="searchData"
            class="adminList">
            <el-table-column
              slot="lastColumn"
              label="操作"
              width="280">
              <template slot-scope="scope">
                <el-button
                  size="small"
                  type="primary"
                  @click="handleEdit(scope)">编辑</el-button>
              </template>
            </el-table-column>
          </jm-tableList>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
  .button{
    margin: 30px;
  }
  .add_button{
    margin-bottom: 20px;
  }
</style>
<script>
import crumbs from '@/components/tool/crumbs.vue';
import toolbar from '@/components/tool/toolbar.vue';
import tableList from '@/components/data/tableList.vue';
import { jmDictSelect } from '@/components/tool/index.js';

let searchData = {
  time: '', // 目标时间
  departmentId: '', // 报账部门
};

export default {
  data() {
    return {
      department: [],
      searchData: Object.assign({}, searchData),
      refresh: false,
      ds: {},
      selectVal: []
    };
  },
  created() {
    this.$http._post({
      url: '/index/B_I_Department/department',
    }).then(({ data }) => {
      this.department = data.department;
    });
  },
  components: {
    'jm-crumbs': crumbs,
    'jm-toolbar': toolbar,
    'jm-tableList': tableList,
    jmDictSelect,
  },
  methods: {
    // 表单提交
    sendForm() {
      this.refresh = true;
    },
    // 重置表单
    resetForm() {
      this.searchData = Object.assign({}, searchData);
    },
    // 编辑
    handleEdit(scope) {
      this.$router.push({ name: 'departmentMoneyEdit', params: { id: scope.row.id } });
    },
    // 添加
    handleAdd() {
      this.$router.push({ name: 'departmentMoneyNew' });
    },
  },
};
</script>

